import { render, staticRenderFns } from "./GoingToTheDoctor.vue?vue&type=template&id=6516f378&"
import script from "./GoingToTheDoctor.vue?vue&type=script&lang=js&"
export * from "./GoingToTheDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports